module.exports = __webpack_public_path__ + "img/key-features.fe8e0ebe.png";